import React from "react";

export default function ChevronDownLight({ className }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 15.556 15.556"
      className={className}
    >
      <path
        id="Path_283"
        data-name="Path 283"
        d="M0,10V0H10"
        transform="translate(7.778 0.707) rotate(45)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1"
      />
    </svg>
  );
}
